import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ResultConfigViewModel } from 'src/app/models/results/result-config-view-model';
import { InventoryItemDTO } from 'src/app/models/results/inventory-item-dto';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class MockDataService implements DataService {

  constructor() { }

  updateResultConfigItem(item: ResultConfigViewModel): Promise<void> {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  getAdminEmailAddresses(): Observable<string[]> {
    return of(["test"]);
  }

  executeDatabaseQuery(): Observable<InventoryItemDTO[]> {
    return of([]);
  }
}
